/**
 * comeinUrl                接口请求地址
 * comeinImageUrl           图片地址
 * comeinFileUrl            文件地址
 * */

import { isBuild } from '@/utils/const';

let comeinUrl;

// 环境区分
if (isBuild) {
	// 生产环境
	comeinUrl = 'https://server.comein.cn/comein';
} else {
	// 测试环境
	comeinUrl = 'https://testserver.comein.cn/comein';
}

export const COMEIN_URL = window.comeinUrl || comeinUrl;
